import { GridUtils, Link } from '@atlassian/amkt-common';
import { LinkUtils } from '@atlassian/mpac-utils';
import React, { useEffect } from 'react';
import { ScreenClassRender } from 'react-grid-system';
import { ErrorView as ErrorViewStyled, ErrorViewImage, ErrorViewInner, GoBackLink, Heading, MoreInfo, Text } from "./ErrorView.styles";
export default function ErrorView(props) {
  const onClickBack = event => {
    event.preventDefault();

    if (props.history) {
      props.history.goBack();
    } else {
      window.history.back();
    }
  };

  const onSearchForApps = event => {
    if (props.history) {
      LinkUtils.maybeOpenInNewTab(event, () => {
        var _props$history;

        (_props$history = props.history) === null || _props$history === void 0 ? void 0 : _props$history.push({
          pathname: props.homeLink.get('href')
        });
      });
    }
  };

  const getErrorCodeText = () => {
    const {
      statusCode
    } = props;

    if (statusCode === 404) {
      return 'if you think this page should be here';
    }

    return "if this problem doesn't resolve itself";
  };

  const renderNotFound = sc => {
    const errorCodeText = getErrorCodeText();
    return /*#__PURE__*/React.createElement(ErrorViewStyled, {
      padding: GridUtils.triFoldScreenClass(sc)('50px 25px', '80px 40px', '100px 50px')
    }, /*#__PURE__*/React.createElement(ErrorViewInner, null, /*#__PURE__*/React.createElement(ErrorViewImage, {
      src: props.image,
      alt: "photo depicting an error"
    }), /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(Heading, null, props.heading), /*#__PURE__*/React.createElement(MoreInfo, null, /*#__PURE__*/React.createElement("span", null, props.primaryMessage, ". You can", ' ', !props.hideGoBackLink ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GoBackLink, {
      onClick: onClickBack
    }, "go back"), ",", ' ') : null), /*#__PURE__*/React.createElement(Link, {
      href: props.homeLink.get('href'),
      onClick: onSearchForApps,
      "data-testid": "search-for-apps"
    }, "search for apps"), ",", /*#__PURE__*/React.createElement("span", null, " or ", errorCodeText, ", feel free to "), /*#__PURE__*/React.createElement(Link, {
      href: "http://go.atlassian.com/marketplace-support",
      rel: "noopener noreferrer",
      target: "_blank"
    }, "contact our support team"), "."))));
  };

  useEffect(() => {
    // SEO4Ajax sets onCaptureReady on window - when SEO4Ajax is rendering this error page, we can execute it
    // with a status code so that we can override the standard 200 with a more appropriate status code for it to cache
    // (or not cache, if a 5xx) and later return to bots
    if (window.onCaptureReady) {
      window.onCaptureReady(props.statusCode);
    }
  }, []);
  return /*#__PURE__*/React.createElement(ScreenClassRender, {
    render: renderNotFound
  }, /*#__PURE__*/React.createElement("span", null));
}